import { Button, Dropdown, Image, TableColumnsType, Tooltip } from "antd";
import Header from "../../../atoms/Header";
import TableUi from "../../../atoms/Table";
import DashboardTemplate from "../../../templates/Dashboard";
import Filters from "./Components/Filters";
import { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../config/hooks";
import { useLocation, useNavigate } from "react-router-dom";
import { CrossIcon, DeleteIcon, NeedHelp } from "../../../atoms/CustomIcons";
import { AxiosError } from "axios";
import { ErrorMessage } from "../../../atoms/Toasts/ErrorMessage";
import { PopUp } from "../../../atoms/PopUp";
import ConfirmDelete from "../../../atoms/ConfirmDelete";
import EmptyCard from "../../../atoms/EmptyCard";
import { CrewYardTableType } from "./ducks/types";
import { getCrewYardListing, removeCrewYardListingData } from "./ducks/actions";
import { deleteCrewYard } from "./ducks/services";
import { SuccessMessage } from "../../../atoms/Toasts/SuccessMessage";
import { PhoneInput } from "react-international-phone";
import { MoreOutlined } from "@ant-design/icons";
import { PAGE_LIMIT } from "../../../config/utils";

export default function Employees() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const url = useLocation();
  const id = url?.pathname.split("/")[3];
  const crewYardListing = useAppSelector(
    (state) => state?.crewYard?.crewYardData
  );

  const [pagination, setPagination] = useState(1);
  const [limit, setLimit] = useState(PAGE_LIMIT);
  const [tableRecord, setTableRecord] = useState<CrewYardTableType | null>(
    null
  );
  const [loading, setLoading] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [isAllDeleteModalOpen, setIsAllDeleteModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deactivated, isDeactivated] = useState(false);
  const dropdownRef = useRef<HTMLButtonElement>(null);

  const [filters, setFilters] = useState<{
    search_text: string | undefined;
    state: string[] | undefined;
    city: string[] | undefined;
    crew: string[] | undefined;
  }>({
    search_text: undefined,
    state: undefined,
    city: undefined,
    crew: undefined,
  });

  const fetchUserListing = () => {
    const payload = {
      offset: pagination > 1 ? limit * (pagination - 1) : pagination - 1,
      limit: limit,
      company_id: id,
    };
    dispatch(getCrewYardListing(payload));
  };

  const items = [
    {
      key: "1",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/table/edit-icon.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
            navigate(
              `/company-settings/edit-crew-yard/${id}/${tableRecord?.id}`
            );
          }}
        >
          Edit
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button
          type="text"
          className="delete-hover"
          icon={<DeleteIcon />}
          onClick={(e) => {
            e.stopPropagation();
            setIsDeleteModalOpen(true);
            if (dropdownRef.current) {
              dropdownRef?.current?.click(); // Simulate a click to close
            }
          }}
        >
          Delete
        </Button>
      ),
    },
  ];

  const columns: TableColumnsType<CrewYardTableType> = [
    {
      title: "Full name",
      dataIndex: "name",
      width: 250,
      fixed: "left",
      sorter: (a, b) =>
        (a?.name ?? "").toString().localeCompare((b?.name ?? "").toString()),
      render: (text: string) => (
        <Tooltip title={text ? text : "-"}>
          <span className="table-col-ellipsis" style={{ maxWidth: "240px" }}>
            {text ? text : "-"}
          </span>
        </Tooltip>
      ),
    },
    {
      title: "Crews assigned",
      dataIndex: "crews",
      width: 230,
      render: (text) =>
        text?.length > 0
          ? text?.map((crew: { name: string }) => crew.name).join(", ")
          : "-",
    },
    {
      title: "City",
      dataIndex: "city",
      width: 140,
      render: (text: string) => (
        <Tooltip title={text ? text : "-"}>
          <span className="table-col-ellipsis" style={{ maxWidth: "130px" }}>
            {text ? text : "-"}
          </span>
        </Tooltip>
      ),
    },
    {
      title: "State",
      dataIndex: "state",
      width: 140,
      render: (text: string) => (
        <Tooltip title={text ? text : "-"}>
          <span className="table-col-ellipsis" style={{ maxWidth: "130px" }}>
            {text ? text : "-"}
          </span>
        </Tooltip>
      ),
    },
    {
      title: "Street address",
      dataIndex: "address",
      width: 250,
      render: (text: string) => (
        <Tooltip title={text ? text : "-"}>
          <span className="table-col-ellipsis" style={{ maxWidth: "240px" }}>
            {text ? text : "-"}
          </span>
        </Tooltip>
      ),
    },
    // {
    //   title: "ZIP",
    //   dataIndex: "zip",
    //   width: 250,
    //   render: (text) => text ?? "-",
    // },
    {
      title: "Contact person",
      dataIndex: "cont_person_first_name",
      width: 250,
      render: (text, record) =>
        text || record?.cont_person_last_name
          ? `${text ?? ""} ${record?.cont_person_last_name ?? ""}`
          : "-",
    },
    {
      title: "Phone",
      dataIndex: "cont_person_phone",
      width: 173,
      render: (text) => (text ? <PhoneInput disabled value={text} /> : "-"),
    },
    {
      title: "Email",
      dataIndex: "cont_person_email",
      width: 250,
      render: (text) => text ?? "-",
    },
    {
      title: <Image src="/images/table/menu-burger.svg" preview={false} />,
      dataIndex: "action",
      width: 52,
      fixed: "right",
      render: (_text, record) => (
        <Dropdown
          menu={{
            items,
          }}
          trigger={["click"]}
          placement="bottomRight"
          className="actionButton"
        >
          <Button
            onClick={(e) => {
              console.log("text", record);
              setTableRecord(record);
              e.stopPropagation();
            }}
            onKeyDown={(e) => e.stopPropagation()}
            style={{
              padding: "6px",
              height: "auto",
              background: "transparent",
            }}
            className="only_icon"
            icon={<MoreOutlined />}
            ref={dropdownRef}
          />
        </Dropdown>
      ),
    },
  ];

  useEffect(() => {
    if (id) {
      const payload = {
        crew: filters?.crew ? filters?.crew : undefined,
        state: filters?.state ? filters?.state : undefined,
        city: filters?.city ? filters?.city : undefined,
        search_text: filters?.search_text || undefined,
        offset: pagination > 1 ? limit * (pagination - 1) : pagination - 1,
        limit: limit,
        company_id: id,
      };
      dispatch(getCrewYardListing(payload));
    }
  }, [dispatch, filters, pagination, limit, id]);

  const deleteFunction = () => {
    setLoading(true);
    deleteCrewYard(
      selectedRowKeys?.length > 0 ? selectedRowKeys : [tableRecord?.id || ""]
    )
      .then(() => {
        setLoading(false);
        setIsDeleteModalOpen(false);
        setIsAllDeleteModalOpen(false);
        setSelectedRowKeys([]);
        fetchUserListing();
        SuccessMessage(
          `Crew ${selectedRowKeys?.length === 1 ? "yard" : "yards"} deleted`
        );
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          setLoading(false);
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
        } else {
          setLoading(false);
          ErrorMessage("Something went wrong");
        }
      });
  };

  const confirmDeletePopUp = {
    visibility: isDeleteModalOpen,
    content: (
      <ConfirmDelete
        title=""
        onClose={() => setIsDeleteModalOpen(false)}
        heading="Confirm deletion"
        paragraph={
          <>
            Are you sure you want to delete <b>{tableRecord?.name}</b>?<br />
            This action cannot be undone.
          </>
        }
        btnText="Delete crew yard"
        btnApi={deleteFunction}
        loading={loading}
      />
    ),
    width: 480,
    onCancel: () => setIsDeleteModalOpen(false),
  };

  useEffect(() => {
    dispatch(removeCrewYardListingData());
  }, [dispatch]);

  const deleteAllUsersPopUp = {
    visibility: isAllDeleteModalOpen,
    content: (
      <ConfirmDelete
        title=""
        onClose={() => setIsAllDeleteModalOpen(false)}
        heading="Confirm deletion"
        paragraph={
          <>
            Are you sure you want to delete the selected crew yards? <br />
            This action cannot be undone.
          </>
        }
        btnText={
          selectedRowKeys.length === 1
            ? "Delete 1 crew yard"
            : `Delete ${selectedRowKeys.length} crew yards`
        }
        btnApi={deleteFunction}
        loading={loading}
      />
    ),
    width: 480,
    onCancel: () => setIsAllDeleteModalOpen(false),
  };

  return (
    <DashboardTemplate loading={crewYardListing?.loader || loading}>
      <Header
        breadcrumb={[
          { label: "Company settings", href: `/company-settings/${id}` },
          { label: "Crew yards" },
        ]}
        title="Crew yards"
        description="Locations where crews start their day, store equipment and materials."
        btnText1="Need help?"
        btnIcon1={<NeedHelp />}
      />
      <TableUi<CrewYardTableType>
        columns={columns}
        data={{
          count: crewYardListing?.count,
          data: crewYardListing?.data || [],
        }}
        filters={
          <Filters
            setFilters={setFilters}
            filters={filters}
            deactivated={deactivated}
            isDeactivated={isDeactivated}
          />
        }
        pageSize={limit}
        setPageSize={setLimit}
        setCurrentPage={setPagination}
        currentPage={pagination}
        selectedRowKeys={selectedRowKeys}
        setSelectedRowKeys={setSelectedRowKeys}
        createButtonText="Add crew yard"
        createButtonLink={`/company-settings/add-crew-yard/${id}`}
      />
      {crewYardListing?.count === 0 && (
        <div className="empty_wrap">
          <EmptyCard
            imageHeight={282}
            title={
              filters?.search_text
                ? "No results match the filter or search criteria"
                : `There are no crew yards.`
            }
            description={
              filters?.search_text
                ? "Try adjusting the filters and search."
                : "Click the button below to add crew yard."
            }
            image="/images/empty-icons/no-active.svg"
            btnText={filters?.search_text ? "" : "Add crew yard"}
            btnLink={
              filters?.search_text
                ? ""
                : `/company-settings/add-crew-yard/${id}`
            }
          />
        </div>
      )}

      {selectedRowKeys?.length !== 0 ? (
        <div className="selection_bar" style={{ minWidth: "235px" }}>
          <div className="selected_count">
            <Button
              icon={<CrossIcon style={{ color: "white" }} />}
              className="only_icon"
              type="text"
              onClick={() => setSelectedRowKeys([])}
            />
            {selectedRowKeys.length}{" "}
            {`${selectedRowKeys.length === 1 ? "crew yard " : "crew yards "}`}
            selected
          </div>
          <div className="selection_buttons">
            <Button
              type="text"
              icon={<DeleteIcon />}
              onClick={() => {
                setIsAllDeleteModalOpen(true);
              }}
            >
              Delete
            </Button>
          </div>
        </div>
      ) : null}

      <PopUp {...confirmDeletePopUp} />
      <PopUp {...deleteAllUsersPopUp} />
    </DashboardTemplate>
  );
}
